import { jsx as _jsx } from "react/jsx-runtime";
import DOMPurify from 'dompurify';
import UIComponent from './uiComponent';
const HtmlRenderer = ({ htmlString, styling }) => {
    const cleanHTML = DOMPurify.sanitize(htmlString);
    return _jsx("div", { style: { textAlign: 'justify', marginBottom: '20px', ...styling }, dangerouslySetInnerHTML: { __html: cleanHTML } });
};
export default class UIText extends UIComponent {
    text;
    style;
    constructor(s) {
        super(s);
        this.text = this.getProperty('text');
        this.style = this.getProperty('style', '');
    }
    getComponent() {
        return _jsx(HtmlRenderer, { htmlString: this.text, styling: this.style });
    }
}
//# sourceMappingURL=uiText.js.map